<SettingsLayout page='settings/about' label="About Semaphore">
  <div>
    <h1>About Semaphore</h1>

    <h2>Version {version}</h2>

    {@html "<p> Semaphore is <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/NickColley/semaphore\">free and open-source software</a> maintained by <a rel=\"noopener\" target=\"_blank\" href=\"https://nickcolley.co.uk\">Nick Colley</a> and distributed under the <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/NickColley/semaphore/blob/main/LICENSE\">GNU Affero General Public License</a>. It is a continuation of the Pinafore project created by <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a>. This is the \"Chost\" patch by <a href=\"https://blackle-mori.com/\">Blackle Mori</a>. </p> <h2 id=\"privacy-policy\">Privacy Policy</h2> <p> Semaphore does not store any personal information on its servers, including but not limited to names, email addresses, IP addresses, posts, and photos. </p> <p> Semaphore is a static site. All data is stored locally in your browser and shared with the fediverse instance(s) you connect to. </p> <h2>Credits</h2> <p> Icons provided by <a rel=\"noopener\" target=\"_blank\" href=\"http://fontawesome.io/\">Font Awesome</a>. </p> <p> Logo thanks to \"Flag\" by AFY Studio from <a rel=\"noopener\" target=\"_blank\" href=\"https://thenounproject.com/\">the Noun Project</a>. </p>"}
  </div>
</SettingsLayout>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'

  const version = process.env.PINAFORE_VERSION

  export default {
    components: {
      SettingsLayout
    },
    data: () => ({
      version
    })
  }
</script>
